import { Position, Trade } from '@/types';

export const mockTrades: Trade[] = [
  {
    id: 'trade-1',
    marketId: 'portugal-presidential',
    outcomeId: 'mendes',
    userId: 'user-1',
    amount: 100,
    price: 0.72,
    isBuy: true,
    createdAt: '2024-12-15T10:30:00Z',
  },
  {
    id: 'trade-3',
    marketId: 'democratic-nominee-2028',
    outcomeId: 'newsom',
    userId: 'user-1',
    amount: 200,
    price: 0.36,
    isBuy: false,
    createdAt: '2024-12-14T16:00:00Z',
  },
];

export const mockPositions: Position[] = [
  {
    marketId: 'portugal-presidential',
    outcomeId: 'mendes',
    outcomeName: 'Luís Marques Mendes',
    marketTitle: 'Portugal Presidential Election',
    shares: 138,
    avgPrice: 0.72,
    currentPrice: 0.72,
    pnl: 0,
    pnlPercent: 0,
  },
];
